import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

export const initReviews = () => {
  const $carousel = $('.reviews__slider');
  const carouselSettings = {
    items: 1,
    loop: true,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    animateIn: 'reviews-in',
    animateOut: 'reviews-out',
  };

  $carousel.owlCarousel(carouselSettings);
}
